/**
 * tour.js
 */

import React from 'react';
import { useTheme, darken } from '@mui/material';
//import recordsPageSteps from './steps/records-page-steps';
import Joyride from "react-joyride";
import { UserContext } from 'contexts/user/user-context';


export default function Tour(props) {
  const {
    run,
    stepIndex,
    handleTourCallback,
    steps
  } = props;
  const theme = useTheme();
  const { user } = React.useContext(UserContext);

  if (!user.role.isHandler) return null;

  const styles = {
    options: {
      beaconSize: theme.spacing(5),
      primaryColor: theme.palette.secondary.dark,
      overlayColor: 'rgba(0, 0, 0, 0.2)',
      textColor: theme.palette.grey[500],
      width: theme.spacing(72),
      zIndex: 1300,
    },
    buttonNext: {
      backgroundColor: 'white',
      color: theme.palette.primary.main,
      fontSize: theme.typography.button.fontSize,
      padding: 0,
      textTransform: 'uppercase',
    },
    buttonSkip: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.sizes[0],
      padding: 0,
      textTransform: 'uppercase',
    },
    buttonClose: {
      padding: theme.spacing(2.5),
    },
    tooltipTitle: {
      color: darken(theme.palette.primary.main, 0.2),
      fontWeight: 'normal',
    },
    tooltip: {
      borderRadius: 0,
      padding: theme.spacing(2.5),
    },
    tooltipFooter: {
      marginTop: theme.spacing(1),
    },
    spotlight: {
      border: `5px solid ${theme.palette.secondary.colors[2]}`,
      borderRadius: theme.spacing(2),
    },
  };


  return (
    <Joyride
      debug={false}
      continuous={true}
      hideBackButton={true}
      spotlightClicks={true}
      disableOverlayClose={true}
      disableScrollParentFix={true} // fixes drawer scrollbar behavior issues
      scrollDuration={10}
      scrollOffset={84}
      showProgress={true}
      steps={steps}
      stepIndex={stepIndex}
      run={run}
      callback={handleTourCallback}
      styles={styles}
    />
  );
}